document.addEventListener("DOMContentLoaded", function () {

  /* ==========================
     Custom File Upload
  =========================== */

  const uploadInput = document.querySelector(".upload-box input[type='file']");
  const uploadBox = document.querySelector(".upload-box");

  if (uploadInput && uploadBox) {

    const text = uploadBox.querySelector("p");

    uploadInput.removeAttribute("disabled");

    uploadInput.addEventListener("change", function () {

      if (this.files.length > 0) {
        text.innerHTML = this.files[0].name;
        uploadBox.classList.add("uploaded");
      } else {
        text.innerHTML = "Drag & Drop or Click to Upload";
        uploadBox.classList.remove("uploaded");
      }

    });

    uploadBox.addEventListener("click", function () {
      uploadInput.click();
    });

  }

  /* ==========================
      Input Focus
  =========================== */

  document.querySelectorAll(".field input, .field textarea, .field select").forEach(function (field) {

    field.addEventListener("focus", function () {
      this.parentElement.classList.add("focused");
    });

    field.addEventListener("blur", function () {

      if (this.value === "") {
        this.parentElement.classList.remove("focused");
      }

    });

  });

  /* ==========================
      Success Message Auto Hide
  =========================== */

  const success = document.querySelector(".form-success");

  if (success) {

    setTimeout(function () {

      success.style.transition = ".4s";
      success.style.opacity = "0";

      setTimeout(function () {
        success.style.display = "none";
      }, 400);

    }, 5000);

  }

  /* ==========================
      Submit Button Loading
  =========================== */

  const form = document.querySelector(".contact-right form");

  if (form) {

    form.addEventListener("submit", function () {

      const btn = form.querySelector(".contact-submit");

      if (btn) {

        btn.disabled = true;
        btn.innerHTML = "Submitting...";

      }

    });

  }

});

document.addEventListener("DOMContentLoaded", function () {

  const fileInput = document.querySelector(".upload-box input[type='file']");
  const uploadText = document.querySelector(".upload-box .file-text-right");

  if (!fileInput) return;

  // Allowed MIME types
  const allowedTypes = [
    "image/png",
    "image/jpeg",
    "application/pdf"
  ];

  // Also check extensions (extra safety)
  const allowedExtensions = ["png", "jpg", "jpeg", "pdf"];

  fileInput.addEventListener("change", function () {

    if (!this.files.length) return;

    const file = this.files[0];

    const extension = file.name.split(".").pop().toLowerCase();

    if (
      !allowedTypes.includes(file.type) ||
      !allowedExtensions.includes(extension)
    ) {

      alert("Only PNG, JPG, JPEG and PDF files are allowed.");

      this.value = "";

      if (uploadText) {
        uploadText.innerHTML =
          "Recommended: PNG, JPG, PDF <br> Max file size: 10MB";
      }

      return;
    }

    // Max file size 10MB
    if (file.size > 10 * 1024 * 1024) {

      alert("Maximum file size is 10MB.");

      this.value = "";

      if (uploadText) {
        uploadText.innerHTML =
          "Recommended: PNG, JPG, PDF <br> Max file size: 10MB";
      }

      return;
    }

    // Valid file
    if (uploadText) {
      uploadText.textContent = file.name;
    }

  });

});
